import i18next from 'i18next';
import HtmlNode from '../Extension/HtmlNode';
import { MarketCode } from '../../@types/MarketCode';
import { getSymbolLogotype } from '../../Templates/Logotype';

interface ModalFooterProps {
  readonly id: string;
  readonly market?: MarketCode;
}
class ModalFooter extends HtmlNode {
  private readonly props: ModalFooterProps;

  constructor(element: HTMLElement, props: ModalFooterProps) {
    super(element, {
      htmlTag: 'footer',
      className: 'waykevaluation-modal__footer',
      id: props.id,
    });

    this.props = props;
    this.render();
  }

  render() {
    this.node.innerHTML = `
      <div class="waykevaluation-hstack waykevaluation-hstack--spacing-1 waykevaluation-hstack--align-center">
        <div class="waykevaluation-hstack__item waykevaluation-hstack__item--no-shrink">
          ${getSymbolLogotype({
            market: this.props.market,
            className: 'waykevaluation-modal__footer-logo',
          })}
        </div>
        <div class="waykevaluation-hstack__item">
          ${i18next.t('footer.poweredByBrand', {
            link: `
              <a
                href="${i18next.t('footer.poweredByBrandLinkUrl')}"
                title="${i18next.t('footer.poweredByBrandLinkTitle', {
                  website: i18next.t('global.brandWebsiteUrl'),
                })}"
                target="_blank"
                rel="noopener noreferer"
                class="waykevaluation-link waykevaluation-link--no-external-icon waykevaluation-link--current-color waykevaluation-link--underline"
              >
                ${i18next.t('global.brandName')}
              </a>
            `,
            interpolation: { escapeValue: false },
          })}
        </div>
      </div>
    `;
  }
}

export default ModalFooter;
